<template>
  <div class="page-container">

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container" style="padding: 10px">
        <Table-filter
          title="明细"
          :show-custome="false"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          @confirm="tableConfigConfirm"
        >
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @cell-dblclick="cellClick"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { apiGetDropvalue } from '@/api/sap/common-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/Chfl'

// 接口入口
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 40 }
        ],
        data: []
      },
      tableData: [],
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {},
  created() {
    this.initPage(pageConfig)
    this.queryData()
  },
  methods: {
    initPage(pageConfig) {
      const columns = []
      const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }
        columns.push(obj)

        if (pageConfig[key].type) {
          searchField[key] = pageConfig[key]
        }
      })

      if (Object.keys(this.pageSearch).length) {
        Object.assign(this.pageSearch, searchField)
        this.searchField = this.pageSearch
      } else {
        this.searchField = searchField
      }
      this.gridOptions.columns = this.gridOptions.columns.concat(columns)
    },
    async queryData(page, ranges) {
      const { DATA } = await apiGetDropvalue('A0019', ranges)
      this.gridOptions.data = DATA
      this.loading = false
    },
    cellClick({ row, rowIndex, column }) {
      this.$refs.xTable.setCheckboxRow(row, true)
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        resolve(this.$refs.xTable.getCheckboxRecords())
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-query {
  /deep/ .el-form-item__content{
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/Chfl.vue